module.exports = __webpack_public_path__ + "static/images/movie-calendar.1f50209.jpg";